import React, { Component } from "react"
import * as styles from "./wechatBountyContest.module.scss"
import WeChatLogo from "../../../../assets/wechat-logo.png"

class WeChatBountyContest extends Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.en = this.en.bind(this)
    this.ct = this.ct.bind(this)
  }
  en() {
    return (
      <button
        className={styles.wechatButton}
        onClick={this.props.handleWeChatLogin}
      >
        <div className={styles.wechatImg}>
          <img src={WeChatLogo} height="18" width="18" alt="wechat logo" />
        </div>
        <span className={styles.wechatTxt}>{this.props.buttonText}</span>
      </button>
    )
  }

  ct() {
    return (
      <button
        className={styles.wechatButton}
        onClick={this.props.handleWeChatLogin}
      >
        <div className={styles.wechatImg}>
          <img src={WeChatLogo} height="18" width="18" alt="wechat logo" />
        </div>
        <span className={styles.wechatTxt}>{this.props.buttonText}</span>
      </button>
    )
  }

  render() {
    if (this.props.lang === "ct") {
      return this.ct()
    }

    return this.en()
  }
}

export default WeChatBountyContest
